// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ce1a53b0","453":"8b437e98","918":"00ed6da7"}[chunkId] + ".chunk.js";
};